export const STATE_KEY_NAME = 'router';
